import React, { useEffect, useState } from 'react';
import PlusSquared from '../../Images/PlusSquared.svg'
import FolderSvg from '../../Images/folder.svg'
import "./About.css"
import api from '../../Components/RefreshToken/RefreshToken';
import axios from 'axios';
import { MAIN_URL } from '../../constants';
import { toast } from 'react-toastify';

const AboutUs = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [addFileName, setAddFileName] = useState()
    const [addFilePdf, setAddFilePdf] = useState()
    const TOKEN = localStorage.getItem("admin_token")
    const [partnersInfo, setPartnersInfo] = useState()
    const [deletedIsOpen, setDeletedIsopen] = useState(false)
    const [deletedId, setDeletedId] = useState()
    const [aboutData, setAboutData] = useState({
        title: '',
        description: '',
    });
    const [aboutInfo, setAboutInfo] = useState()
    const [aboutId, setAboutId] = useState()
    useEffect(() => {
        api.get(`${MAIN_URL}/management/about-us`,).then((res) => {
            setAboutInfo(res.data)
            console.log("about", res.data)
        }).catch((err) => {
            console.log(err)
        })
    }, [isModalOpen])
    useEffect(() => {
        api.get(`/management/partners`,).then((res) => {
            setPartnersInfo(res.data)
        }).catch((err) => {
            console.log(err)
        })
    }, [isModalOpen])
    const handleImgChange = (e, id) => {
        const file = e.target.files[0];
        setAboutId(id);

        if (file) {
            const imgUrl = URL.createObjectURL(file);

            if (location.includes("about")) {
                setAboutInfo(prev =>
                    prev.map(item =>
                        item.id === id ? { ...item, photo: imgUrl, selectedFile: file } : item
                    )
                );
            } else {
                setPartnersInfo(prev =>
                    prev.map(item =>
                        item.id === id ? { ...item, photo: imgUrl, selectedFile: file } : item
                    )
                );
            }
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file && file.type.includes("image")) {
            setAboutData(prev => ({
                ...prev,
                photo: file
            }));
            setAddFileName(file.name);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAboutData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleOpen = () => {
        setIsModalOpen(x => !x)
    }
    const [language, setLanguage] = useState("")
    const handleSubmitAbout = (e) => {
        e.preventDefault();
        setLoading(true);
        console.log("til", language)
        const formData = new FormData();
        formData.append("title", aboutData?.title);
        formData.append("description", aboutData?.description);
        formData.append("language", language);
        if (aboutData?.photo) {
            formData.append("photo", aboutData?.photo);
        }

        axios.post(`${MAIN_URL}/management/about-us`, formData, {
            headers: {
                "Authorization": `Bearer ${TOKEN}`,
                "Content-Type": "multipart/form-data",
            },
        }).then((res) => {
            toast.success("About successfully added");
            setLoading(false);
            setIsModalOpen(false);
            setAboutData("");
            setAddFileName("");
            setLanguage("");
        }).catch((err) => {
            console.error("Error:", err);
            setLoading(false);
        });
    };

    const handleSubmitPartners = (e) => {
        e.preventDefault();
        setLoading(true)

        const formData = new FormData();
        formData.append("title", aboutData?.title);
        formData.append("description", aboutData?.description);
        formData.append("language", language);
        if (aboutData?.photo) {
            formData.append("photo", aboutData?.photo);
        }
        axios.post(`${MAIN_URL}/management/partners`, formData, {
            headers: {
                "Authorization": `Bearer ${TOKEN}`,
                "Content-Type": "multipart/form-data",
            },
        }).then((res) => {
            toast.success("About successfully added")
            setLoading(false)
            setIsModalOpen(false)
            setAboutData("")
            setAddFileName("")
        }).catch((err) => {
            console.error("Error:", err);
            setLoading(false)
        });
    };

    const handleAboutInfoChange = (e, id) => {
        const { name, value } = e.target;
        setAboutId(id);
        if (location.includes("about")) {
            setAboutInfo(prev =>
                prev.map(item =>
                    item.id === id ? { ...item, [name]: value } : item
                )
            );
        } else {
            setPartnersInfo(prev =>
                prev.map(item =>
                    item.id === id ? { ...item, [name]: value } : item
                )
            );
        }
    };


    const updateAbout = (id) => {
        const updatedItem = aboutInfo.find(item => item.id === id);
        if (!updatedItem) return;
        const formData = new FormData();
        formData.append("title", updatedItem.title);
        formData.append("description", updatedItem.description);
        formData.append("language", language);

        if (updatedItem.selectedFile) {
            formData.append("photo", updatedItem.selectedFile);
        }
        axios.put(`${MAIN_URL}/management/about-us/${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${TOKEN}`
            },
        }).then((res) => {
            toast.success("About successfully updated");
            setLoading(false)
        }).catch((err) => {
            console.error("Error:", err);
            toast.warning("You have not made any changes!!!")
            setLoading(false)
        });
    };

    const updatePartners = (id) => {
        const updatedItem = partnersInfo.find(item => item.id === id);
        if (!updatedItem) return;
        const formData = new FormData();
        formData.append("title", updatedItem.title);
        formData.append("description", updatedItem.description);
        formData.append("language", language);

        if (updatedItem.selectedFile) {
            formData.append("photo", updatedItem.selectedFile);
        }
        axios.put(`${MAIN_URL}/management/partners/${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${TOKEN}`
            },
        }).then((res) => {
            toast.success("About successfully updated");
            setLoading(false)
        }).catch((err) => {
            console.error("Error:", err);
            toast.warning("You have not made any changes!!!")
            setLoading(false)
        });
    };


    const location = window.location.pathname;
    const dataList = location.includes("about") ? aboutInfo : partnersInfo;
    const updateFunction = location.includes("about") ? updateAbout : updatePartners;

    const handleSubmit = (e) => {
        e.preventDefault();
        location.includes("about") ? handleSubmitAbout(e) : handleSubmitPartners(e);
    };

    const handleModalDeleted = () => {
        setDeletedIsopen(x => !x)
    }

    const deletedFunc = () => {
        const deleteEndpoint = location.includes("about") ? `/management/about-us/${deletedId}` : `/management/partners/${deletedId}`
        api.delete(deleteEndpoint, {
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${TOKEN}`
            },
        }).then((res) => {
            console.log(res.data)
            if (location.includes("about")) {
                setAboutInfo(prevList => prevList.filter(item => item.id !== deletedId));
            } else if (location.includes("partners")) {
                setPartnersInfo(prevList => prevList.filter(item => item.id !== deletedId));
            }
            setDeletedIsopen(false)
            toast.success("Deleted successfully")
        }).catch((err) => {
            console.log(err)

        })
    }


    return (
        <div>
            <div className="certificate-title">
                <h1 className='confirm-lesson-title'>{location.includes("about") ? "About Us" : "Partners"}</h1>
                <button onClick={handleOpen} className='icon-div add-certificate'>{location.includes("about") ? "Add About" : "Add Partners"}</button>
            </div>

            {dataList?.map((item) => (
                <div key={item?.id} className="about-card">
                    <div className="about-card-left">
                        <div style={{marginBottom: "30px"}} className="form-group">
                            <select onChange={(e) => setLanguage(e.target.value)}>
                                <option hidden>Select language</option>
                                <option value="en">En</option>
                                <option value="ru">Ru</option>
                                <option value="uz">Uz</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <input required onChange={(e) => handleAboutInfoChange(e, item.id)} value={item.title || ""} type="text" name="title" placeholder="Enter about title" />
                        </div>
                        <div className="form-group">
                            <textarea required onChange={(e) => handleAboutInfoChange(e, item.id)} className='modal-textarea about-text update-about' value={item.description || ""} type="text" name="description" placeholder="Enter about description" />
                        </div>
                    </div>
                    <div className="about-card-right">
                        <div className="edit-img-block about-img-block">
                            <img className='edit-img about-img' src={item?.photo?.startsWith("blob") ? item.photo : `${MAIN_URL}/${item?.photo}`} alt="Course Image" />
                            <div className="img-hover-block about-hover">
                                <label className="edit-icon about-icon">
                                    <i className="ri-pencil-fill black-color"></i>
                                    <input onChange={(e) => handleImgChange(e, item.id)} className='edit-img-input' accept="image/*" type="file" />
                                </label>
                            </div>
                        </div>
                        <div className='about-save'>
                            <button onClick={() => updateFunction(item.id)} className='confirmation-btn about-save-btn'>
                                {loading ? "Saving..." : "Save"}
                            </button>
                        </div>
                    </div>
                    <div onClick={() => { handleModalDeleted(); setDeletedId(item?.id) }} className="delete-about">
                        <i className="ri-delete-bin-6-fill hover-icon"></i>
                    </div>
                </div>
            ))}

            {isModalOpen && (
                <div className="add-certificate-input">
                    <form onSubmit={handleSubmit} id="courseForm" className='course-form-modal about-form'>
                        <select onChange={(e) => setLanguage(e.target.value)}>
                            <option hidden>Select language</option>
                            <option value="en">En</option>
                            <option value="ru">Ru</option>
                            <option value="uz">Uz</option>
                        </select>
                        <label className={`form-group chose-file-box`}>
                            <div className="choseFile">
                                <i className="ri-add-box-line"></i>
                            </div>
                            <p className=''>{addFileName ? addFileName : "Attach photo"}</p>
                            <input required className='input-file-img' type="file" name="photo" placeholder="Attach photo" accept="image/png, image/jpeg, image/jpg, image/gif, image/webp" onChange={handleFileChange} />
                        </label>
                        <div className="form-group">
                            <input required type="text" name="title" placeholder={location.includes("about") ? "Enter about title" : "Enter partners title"} onChange={handleInputChange} />
                        </div>
                        <div className="form-group">
                            <textarea required className='modal-textarea about-text' type="text" name="description" placeholder={location.includes("about") ? "Enter about description" : "Enter partners discription"} onChange={handleInputChange} />
                        </div>
                        <div className="form-modal-footer certificate-btn">
                            <button type='button' onClick={handleOpen} className="form-cancel-btn">
                                Cancel
                            </button>
                            <button className="form-confirm-btn" disabled={loading} >
                                {loading ? "Loading..." : "Added"}
                            </button>
                        </div>
                    </form>
                </div>
            )}

            {deletedIsOpen && (
                <div className="delete-modal">
                    <div className="delete-block">
                        <h4 style={{ textAlign: "center" }}>Are you sure you want to delete it?</h4>
                        <div className="certificate-btn deleted-btn">
                            <button onClick={handleModalDeleted} className="form-cancel-btn delete-btn">Cancel</button>
                            <button onClick={deletedFunc} className="form-confirm-btn delete-btn">OK</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AboutUs;
